var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.910156H6V5.91016H5V2.41016C2.65 3.38016 1 5.70016 1 8.41016C1 11.9902 3.91 14.9102 7.5 14.9102C9.22391 14.9102 10.8772 14.2253 12.0962 13.0063C13.3152 11.7874 14 10.1341 14 8.41016C14 5.33016 11.86 2.75016 9 2.08016V1.05016C12.42 1.75016 15 4.77016 15 8.41016C15 12.5402 11.64 15.9102 7.5 15.9102C5.51088 15.9102 3.60322 15.12 2.1967 13.7135C0.790176 12.3069 0 10.3993 0 8.41016C0 5.63016 1.5 3.21016 3.74 1.91016H1V0.910156Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseReset);
export default __webpack_public_path__ + "static/media/CourseReset.d77bdbc840fcb6f8b52ff1ab6412807c.svg";
export { ForwardRef as ReactComponent };